import React from "react";
import { HiDocumentText } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";

const Setup = () => {
  const navigate = useNavigate();
  
  const setupOptions = [
    {
      id: 1,
      label: "Meeting Heading",
      icon: <HiDocumentText className="text-4xl text-green-600" />,
      path: "/setup/meeting-heading",
    },
  ];

  return (
    <div className="p-0">
      <h1 className="text-2xl font-semibold text-gray-800 mb-8">Setup</h1>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {setupOptions.map((option) => (
          <div
            key={option.id}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 flex flex-col items-center justify-center gap-3 hover:shadow-md hover:border-primary transition-all cursor-pointer"
            onClick={() => navigate(option.path)}
          >
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
              {option.icon}
            </div>
            <p className="text-sm font-medium text-gray-700 text-center">
              {option.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Setup;
